import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { SafePipe } from 'app/event/pipes/safe.pipe';

@Component({
  standalone: true,
  imports:[CommonModule,SafePipe],
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  styleUrl: './iframe.component.scss'
})
export class IframeComponent implements OnInit {

  @Input() handle;
  @Input() ppid;

  private _theme: string = '';

  @Input() 
  set theme(value: any) {
    this._theme = value;
    this.updateSrc();
  };
  get theme(): any {
    return this._theme;
  }

  public src = '';

  constructor() {}

  ngOnInit(): void {
    this.updateSrc();
  }

  updateSrc() {
    this.src = `${window.location.origin}/quickpay.html?handle=${this.handle}&ppid=${this.ppid}&iframe=true&embedded=true&theme=${this.theme}`
  }
}
